import React from 'react';
import { Checkbox } from '../UI/Checkbox';
import { InputField } from '../UI/InputField';
export const Step1JobType = ({
  formData,
  handleInputChange,
  errors,
  touched,
  setTouched
}) => {
  const handleCheckboxChange = (field, value) => {
    handleInputChange('jobTypes', field, value);
  };
  const handleTextChange = value => {
    handleInputChange('jobTypes', 'andersText', value);
  };
  return <div data-id="element-21">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4" data-id="element-22">
        <Checkbox id="schilderwerk" label="Schilderwerk" checked={formData.jobTypes.schilderwerk} onChange={e => handleCheckboxChange('schilderwerk', e.target.checked)} premium={true} data-id="element-23" />
        <Checkbox id="stucwerk" label="Stucwerk" checked={formData.jobTypes.stucwerk} onChange={e => handleCheckboxChange('stucwerk', e.target.checked)} premium={true} data-id="element-24" />
        <Checkbox id="badkamerRenovatie" label="Badkamer renovatie" checked={formData.jobTypes.badkamerRenovatie} onChange={e => handleCheckboxChange('badkamerRenovatie', e.target.checked)} premium={true} data-id="element-25" />
        <Checkbox id="toiletRenovatie" label="Toilet renovatie" checked={formData.jobTypes.toiletRenovatie} onChange={e => handleCheckboxChange('toiletRenovatie', e.target.checked)} premium={true} data-id="element-26" />
        <Checkbox id="aanbouw" label="Aanbouw" checked={formData.jobTypes.aanbouw} onChange={e => handleCheckboxChange('aanbouw', e.target.checked)} premium={true} data-id="element-27" />
        <Checkbox id="completeWoningrenovatie" label="Complete woningrenovatie" checked={formData.jobTypes.completeWoningrenovatie} onChange={e => handleCheckboxChange('completeWoningrenovatie', e.target.checked)} premium={true} data-id="element-28" />
      </div>
      <div className="mt-4" data-id="element-29">
        <Checkbox id="anders" label="Anders" checked={formData.jobTypes.anders} onChange={e => handleCheckboxChange('anders', e.target.checked)} premium={true} data-id="element-30" />
        {formData.jobTypes.anders && <div className="mt-3 ml-7 transform transition-all duration-300 ease-in-out" data-id="element-31">
            <InputField id="andersText" placeholder="Omschrijf uw opdracht" value={formData.jobTypes.andersText} onChange={e => handleTextChange(e.target.value)} error={errors.andersText} onBlur={() => setTouched(prev => ({
          ...prev,
          'jobTypes.andersText': true
        }))} touched={touched['jobTypes.andersText']} premium={true} data-id="element-32" />
          </div>}
      </div>
      {errors.jobTypes && <p className="text-red-500 mt-4 font-medium text-sm" data-id="element-33">
          {errors.jobTypes}
        </p>}
    </div>;
};